"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var styles_1 = require("../../../common/styles");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), styles_1.formattedTextCss);

var Text = function (_a) {
  var text = _a.text,
      _b = _a.className,
      className = _b === void 0 ? '' : _b;
  return react_1["default"].createElement(Wrapper, {
    className: className + " content-text",
    dangerouslySetInnerHTML: {
      __html: text || ''
    }
  });
};

exports["default"] = Text;
var templateObject_1;